export default __webpack_public_path__ + "images/6cbef9471eb03be56f933efdbf6e8841-halloween_new.webp";